





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ProcessNumberCardTemplate extends Vue {
  @Prop({ required: true })
  private totalNumber!: number;

  @Prop({ default: false })
  private hasSubtitle!: boolean;

  @Prop({ default: 0 })
  private thisMonthNumber!: number;

  @Prop({ default: 0 })
  private lastMonthNumber!: number;

  @Prop({ default: 'gradation-blue' })
  private bgColor!: string;

  /**
   * 値が変更される度に、ドラムロールを実行させる
   */
  @Watch('totalNumber')
  updateTotalNumber(newValue: number, oldValue: number) {
    this.totalNumber = newValue;
    this.performDrumRolling(newValue, oldValue);
  }

  /**
   * ドラムロールを演出する可変値
   */
  private rollingCount: number = 0;

  /**
   * setIntervalのタイマー識別用
   */
  private intervalId: number = 0;

  /**
   * ドラムロールの加算値を求めた後、タイマー起動
   */
  private performDrumRolling(targetValue: number, initNumber: number): void {
    // 加算値を求める計算。2%ずつ加算するぐらいが丁度よい。
    const countInterval: number = Math.abs(Math.floor((targetValue - initNumber) * 0.02)) || 1;

    if (initNumber < targetValue) {
      this.intervalId = setInterval(() => this.countUp(targetValue, countInterval), 10); // 10ms毎にcountUpを実行
    }
  }

  /**
   * ドラムロールの値を足す。目標値を超えていたらタイマーを止める
   */
  private countUp(targetValue: number, countInterval: number): void {
    if (targetValue <= this.rollingCount) {
      this.terminateDrumRolling(targetValue);
      return;
    }
    this.rollingCount += countInterval;
  }

  /**
   * ドラムロールの値を目標値に変更し、タイマーを止める
   */
  private terminateDrumRolling(endVal: number): void {
    this.rollingCount = endVal;
    clearInterval(this.intervalId);
  }

  /** 伸び率の計算 */
  private get computePercent() {
    const percent = (this.thisMonthNumber - this.lastMonthNumber ) / this.lastMonthNumber * 100
    const roundDown = Math.floor(percent * Math.pow(10, 2)) / Math.pow(10, 2);
    switch (Math.sign(roundDown)) {
      case 1:
        return `+${roundDown}`;
      case -1:
        return roundDown;
      case 0:
        return `+${roundDown}`
      default:
        return roundDown;
    }
  }
}
